import { MouseEventHandler, ReactNode } from 'react';
import { DotProps } from 'recharts-overriden';

type DotWrapperProps = DotProps & { children: ReactNode };

export const DEFAULT_DOT_RADIUS = 9;

const DotContainer = (props: DotWrapperProps) => {
  const { cx, cy, children } = props;

  if (!cx || !cy) return <></>;

  return <g>{children}</g>;
};

const DefaultDot = ({ fill, ...props }: DotProps) => {
  return (
    <>
      <DotBase {...props} r={DEFAULT_DOT_RADIUS} style={{ fill }} opacity={0.2} />
      <DotBase {...props} r={5} style={{ fill }} strokeWidth={0} />
    </>
  );
};

const ActiveDot = ({ fill, ...props }: DotProps) => {
  return (
    <>
      <DotBase {...props} r={12} style={{ fill: 'white', stroke: 'black', strokeOpacity: 0.1 }} opacity={1} />
      <DotBase {...props} r={7} style={{ fill }} />
    </>
  );
};

const DotBase = ({ r, cx, cy, onMouseEnter, onMouseLeave, style, opacity }: DotProps) => {
  return (
    <circle
      cx={cx}
      cy={cy}
      r={r}
      onMouseEnter={onMouseEnter as MouseEventHandler<SVGCircleElement> | undefined}
      onMouseLeave={onMouseLeave as MouseEventHandler<SVGCircleElement> | undefined}
      style={style}
      opacity={opacity}
    />
  );
};

export const Dot = {
  Container: DotContainer,
  Default: DefaultDot,
  Active: ActiveDot,
};
